export default __webpack_public_path__ + "static/v2_andrei_bw-05c8279baefedfa4b71921af7b39a01d.jpg";